// /////////////////////////////////////////////////////////////
// [ファイル] SalesProjectsDetailPage.tsx
// [概要] 案件詳細・編集の全画面ページ。
//        URL /salesprojectsmanagement/:id でアクセス。
//        親 Layout (SalesProjectsLayout) の Context から refresh() を取得し、
//        編集成功時に一覧側のデータを最新化する。戻るボタンでは一覧側に
//        渡された URL Query を保持して /salesprojectsmanagement へ戻る。
// /////////////////////////////////////////////////////////////
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import SalesProjectsDetailUpdate from './SalesProjectsDetailUpdate';
import { useSalesProjectsTableContext } from '../providers/SalesProjectsTableProvider';

export default function SalesProjectsDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useSalesProjectsTableContext();

  // 一覧から渡された URL Query があれば保持して戻る
  const handleBackToList = () => {
    const state = location.state as { listSearch?: string } | null;
    const searchPart = state?.listSearch || '';
    navigate(`/salesprojectsmanagement${searchPart}`);
  };

  return (
    <SalesProjectsDetailUpdate
      projectId={id}
      onClose={handleBackToList}
      onSaved={() => refresh()}
    />
  );
}
